import {Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, output, input} from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-re-launched-popover',
  templateUrl: './re-launched-popover.component.html',
  styleUrls: ['./re-launched-popover.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbPopover]
})
export class ReLaunchedPopoverComponent implements OnInit {
  readonly newInfluencerCount = input<number>(undefined);
  readonly campaignEmailInfluencerCount = input<number>(undefined);
  readonly container = input(undefined);
  readonly campaignId = input<number>(undefined);
  readonly IsClicked = output<any>();

  constructor() { }

  ngOnInit(): void { }

  relaunch() {
    this.IsClicked.emit(this.campaignId());
  }
}
